// Katalog satırı sürükleme tutamacı (Finar rev-2 #4b/#12b/#14): satır başında ⋮⋮ (32 px görsel,
// 44 px dokunma alanı — `hitArea44`). Fare: tüm satır sürüklenir, tutamaç yalnız görsel ipucu.
// Klavye eşdeğeri: tutamaç odaktayken ↑/↓ bir adım taşır (`onStep`). Tıklama satıra yayılmaz
// (düzenleme penceresi açılmasın). Düzenlenemeyen satırda (yetki) boş hücre — sütun hizası korunur.

import { KPI_COPY } from "../../lib/kpi-ui";
import { hitArea44, hitArea44Visual, tdStyle } from "./kpi-form-styles";

export function CatalogRowGrip(props: {
  label: string;
  /** null = bu satır sürüklenemez (boş hücre) */
  hintId: string | null;
  disabled: boolean;
  onStep: (direction: -1 | 1) => void;
}): JSX.Element {
  const C = KPI_COPY.reorder;
  if (props.hintId === null) return <td style={{ ...tdStyle, width: 44, padding: "4px 0" }} />;
  return (
    <td style={{ ...tdStyle, width: 44, padding: "4px 0" }}>
      <button
        type="button"
        className="kpi-drag-grip"
        data-testid="kpi-catalog-row-grip"
        aria-label={C.gripAria(props.label)}
        aria-describedby={props.hintId}
        title={C.hint}
        disabled={props.disabled}
        style={{ ...hitArea44, margin: 0, ...(props.disabled ? { opacity: 0.5 } : {}) }}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key !== "ArrowUp" && e.key !== "ArrowDown") {
            e.stopPropagation();
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          props.onStep(e.key === "ArrowUp" ? -1 : 1);
        }}
      >
        <span
          aria-hidden="true"
          style={{
            ...hitArea44Visual,
            width: 32,
            padding: 0,
            border: "none",
            background: "transparent",
            color: "var(--color-text-3)",
            letterSpacing: "-0.2em",
          }}
        >
          ⋮⋮
        </span>
      </button>
    </td>
  );
}
